import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

/**
 * Direct selector to the storeInfoPage state domain
 */

const selectStoreInfoPageDomain = (state: ApplicationRootState) => {
  return state ? state.storeInfoPage : initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by StoreInfoPage
 */

const selectStoreInfoPage = () =>
  createSelector(selectStoreInfoPageDomain, substate => {
    return substate;
  });

export default selectStoreInfoPage;
export { selectStoreInfoPageDomain };
